import * as React from 'react';
import { FC } from 'react';
import type { QuickSignupFormProps, Locales, Values, ChangeValues } from './types';

const Country: FC<{
  values: Values;
  changeValues: ChangeValues;
  countries: QuickSignupFormProps['countries'];
  locales: Locales;
}> = ({ values, changeValues, countries, locales }) => (
  <>
    <div className="country-title rs-text-align_center">{locales.country.label}</div>
    <div className="input player_country">
      <select
        id="player_country"
        name="player[country]"
        onChange={(v) => changeValues({ country: v.target.value })}
        value={values.country}
      >
        {countries.map(([code, name]) => (
          <option value={code} key={code}>
            {name}
          </option>
        ))}
      </select>
    </div>
  </>
);

export default Country;
